import React, { createRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { search } from '@debbie/common/dist/util';
import { Input } from '..';
import { useAllCreditors } from '@debbie/cortex/dist/creditors';
import { h } from '@debbie/cortex/dist';
const CreditorSelector = (props) => {
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    const [query, setQuery] = React.useState('');
    const [index, setIndex] = React.useState(0);
    const ref = createRef();
    const relevantCreditors = search(allCreditors || [], (c) => c.name, query, {});
    return allCreditors ? (React.createElement(Wrapper, { onBlur: () => {
            props.close();
        } },
        React.createElement(Input, { placeholder: lang.misc.search, value: query, onChange: (e) => {
                setQuery(e.target.value);
            }, autofocus: true, style: { borderEndEndRadius: 0, borderEndStartRadius: 0 }, onKeyDown: (e) => {
                if (e.key === 'ArrowDown') {
                    setIndex((index + 1) % relevantCreditors.length);
                }
                else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    setIndex((index - 1 + relevantCreditors.length) % relevantCreditors.length);
                }
                else if (e.key === 'Enter') {
                    props.setCreditor(relevantCreditors[index]);
                }
                else if (e.key === 'Escape') {
                    props.close();
                }
                else {
                    setIndex(0);
                    if (ref.current) {
                        ref.current.scroll(0, 0);
                    }
                }
            } }),
        React.createElement(Creditors, { ref: ref }, relevantCreditors.map((creditor, i) => {
            return (React.createElement(Creditor, { key: creditor.creditorId, selected: i === index, onClick: () => props.setCreditor(creditor), onMouseEnter: () => {
                    if (index !== i) {
                        setIndex(i);
                    }
                }, onMouseDown: (e) => {
                    e.preventDefault();
                } }, creditor.name));
        })))) : (React.createElement(React.Fragment, null));
};
const Wrapper = styled.div `
  position: relative;
`;
const Creditors = styled.div `
  max-height: 10rem;
  overflow-y: auto;
  border: 1px solid #ccc;
  position: absolute;
  width: 100%;
  background-color: white;
  z-index: 100;
  box-shadow: 0 0.1rem 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
  margin-top: -20px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
`;
const Creditor = styled.div `
  padding: 0.5rem;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
  background-color: ${(p) => (p.selected ? '#eee' : 'white')};
`;
export default CreditorSelector;
//# sourceMappingURL=CreditorSelector.js.map